module.exports = __webpack_public_path__ + "img/device_icon_title_green.cd5e4450.svg";